import * as ko from "knockout";

export class complaint_request_lines {
  complaint_id: KnockoutObservable<string>;
  complaint_line: KnockoutObservable<number>;
  selection: KnockoutObservable<boolean>;
  position: KnockoutObservable<string>;
  material_no: KnockoutObservable<string>;
  material_description: KnockoutObservable<string>;
  qty_delivered: KnockoutObservable<number>;
  complaint_qty: KnockoutObservable<number>;
  complaint_has_error: KnockoutObservable<boolean>;
  serial_no: KnockoutObservable<string>;
  complaint_serial_no: KnockoutObservable<string>;
  ordered_article: KnockoutObservable<string>;
  comments: KnockoutObservable<string>;
  weight: KnockoutObservable<string>;

  constructor(item) {
    this.complaint_id = ko.observable(item.complaint_id);
    this.complaint_line = ko.observable(item.complaint_line ? parseInt(item.complaint_line, 10) : 0);
    this.selection = ko.observable(item.selection == "Y" ? true : false);
    this.position = ko.observable(item.position);
    this.material_no = ko.observable(item.material_no);
    if (item.part && item.part.internal_descriptn) {
      this.material_description = ko.observable(item.part.internal_descriptn);
    } else {
      this.material_description = ko.observable(item.material_description);
    }

    this.qty_delivered = ko.observable(item.qty_delivered ? parseInt(item.qty_delivered, 10) : 0);
    this.complaint_qty = ko.observable(item.complaint_qty ? parseInt(item.complaint_qty, 10) : 0);
    this.complaint_has_error = ko.observable(false);
    this.serial_no = ko.observable(item.serial_no ? item.serial_no.replace(/,/g, ", ") : "");
    this.complaint_serial_no = ko.observable(item.complaint_serial_no);
    this.ordered_article = ko.observable(item.ordered_article ? item.ordered_article : "");
    this.comments = ko.observable(item.comments);
    this.weight = ko.observable(item.weight);
  }
}
